import { render, staticRenderFns } from "./CoverImagesModal.vue?vue&type=template&id=19b44d01&scoped=true"
import script from "./CoverImagesModal.vue?vue&type=script&lang=ts"
export * from "./CoverImagesModal.vue?vue&type=script&lang=ts"
import style0 from "./CoverImagesModal.vue?vue&type=style&index=0&id=19b44d01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b44d01",
  null
  
)

export default component.exports